// extracted by mini-css-extract-plugin
module.exports = {"item-with-logo":"item-with-logo__10HDZ"};